import React from 'react';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const getDisplayDate = (game) => {
  const value = game.officialDate || String(game.date || '').slice(0, 10);

  try {
    return format(parseISO(value), 'EEE, MMM d yyyy');
  } catch {
    return value || '--';
  }
};

const GameHistoryCard = ({ game }) => {
  const navigate = useNavigate();
  const awayScore = Number(game.away?.score);
  const homeScore = Number(game.home?.score);
  const awayWon = awayScore > homeScore;
  const homeWon = homeScore > awayScore;
  const redSoxHome = game.home?.abbr === 'BOS';
  const redSoxWon = redSoxHome ? homeWon : awayWon;
  const isDoubleHeader =
    game.doubleHeader === 'Y' ||
    Number(game.gameNumber) > 1;

  const openGame = () => {
    if (game.gamePk) {
      navigate(`/game/pk/${game.gamePk}`);
      return;
    }

    if (game.slug) {
      navigate(`/game/${game.slug}`);
    }
  };

  return (
    <button
      type="button"
      onClick={openGame}
      disabled={!game.gamePk && !game.slug}
      className={`flex w-full flex-col gap-2 border p-3 text-left transition-all hover:scale-[1.01] disabled:cursor-not-allowed disabled:opacity-60 ${
        redSoxWon
          ? 'border-[#658d71] bg-[rgba(56,102,70,0.15)] hover:border-[#a9c9b1]'
          : 'border-[rgba(196,51,62,0.4)] bg-[rgba(196,51,62,0.05)] hover:border-[#c4333e]'
      }`}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-[9px] font-bold uppercase tracking-widest text-[#658d71]">
          {getDisplayDate(game)}
        </span>
        <div className="flex items-center gap-1">
          {isDoubleHeader && (
            <span className="border border-[#658d71] px-1.5 py-0.5 text-[8px] font-black uppercase tracking-widest text-[#a9c9b1]">
              Game {game.gameNumber || 2}
            </span>
          )}
          <span
            className={`px-1.5 py-0.5 text-[9px] font-black uppercase tracking-widest ${
              redSoxWon
                ? 'bg-[#386646] text-[#a9c9b1]'
                : 'bg-[rgba(196,51,62,0.3)] text-[#e6a8a8]'
            }`}
          >
            {redSoxWon ? 'W' : 'L'}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between gap-2">
        <div className="flex flex-col items-start">
          <span className={`text-xs font-black uppercase tracking-wide ${awayWon ? 'text-white' : 'text-[#658d71]'}`}>
            {game.away?.abbr || 'AWY'}
          </span>
          <span className={`text-2xl font-black tabular-nums ${awayWon ? 'text-white' : 'text-[#658d71]'}`}>
            {game.away?.score ?? '--'}
          </span>
        </div>

        <span className="text-xs font-bold text-[#658d71]">FINAL</span>

        <div className="flex flex-col items-end">
          <span className={`text-xs font-black uppercase tracking-wide ${homeWon ? 'text-white' : 'text-[#658d71]'}`}>
            {game.home?.abbr || 'HME'}
          </span>
          <span className={`text-2xl font-black tabular-nums ${homeWon ? 'text-white' : 'text-[#658d71]'}`}>
            {game.home?.score ?? '--'}
          </span>
        </div>
      </div>

      <span className="truncate text-[9px] text-[#658d71]">
        {game.venue || '--'}
      </span>
    </button>
  );
};

export default GameHistoryCard;